<fury-page-layout mode="card">
    <fury-page-layout-header>
      <fury-breadcrumbs [@fadeInRight]  current="Page List"></fury-breadcrumbs>
    </fury-page-layout-header>
  
    <fury-page-layout-content [@fadeInUp]>
      <fury-list name={{filterValue}} [columns]="columns" (filterChange)="onFilterChange($event)" [hideSearchInput]="true">
        <div class="actions">
            <button *ngIf="settingList && settingList?.length < 4" class="create" type="button" mat-mini-fab color="primary" [routerLink]="['/settings/page/page-add']">
                <mat-icon>add</mat-icon>
              </button>
        </div>
        <table [dataSource]="dataSource" mat-table matSort>
            <!-- actions Column -->
            <ng-container matColumnDef="actions">
                <th *matHeaderCellDef class="actions-cell" mat-header-cell mat-sort-header>Actions</th>
                <td *matCellDef="let row;let i=index" class="actions-cell" mat-cell>
                    <button type="button" [matMenuTriggerFor]="actionsMenu" (click)="$event.stopPropagation()"
                        mat-icon-button>
                        <mat-icon>more_horiz</mat-icon>
                    </button>
  
                    <mat-menu #actionsMenu="matMenu" yPosition="below" xPosition="before">
                        <button mat-menu-item [routerLink]="['/settings/page/page-edit/'+row?.pageName]">
                            <span>Edit</span>
                        </button>
                    </mat-menu>
                </td>
            </ng-container>
  
            <ng-container matColumnDef="isActive">
              <th mat-header-cell *matHeaderCellDef>Status</th>
              <td mat-cell *matCellDef="let element">
                {{element?.isActive == '1' ? 'Active' : 'Inactive'}}
              </td>
            </ng-container>
            <ng-container matColumnDef="pageName">
              <th mat-header-cell *matHeaderCellDef>Page Name</th>
              <td mat-cell *matCellDef="let element">
                {{(element?.pageName).split('-')[0] | titlecase}}
              </td>
            </ng-container>
  
          <ng-container *ngFor="let column of columns">
            <ng-container [matColumnDef]="column.property" *ngIf="column.property != 'actions' && column.property != 'isActive' && column.property != 'pageName'">
                <th *matHeaderCellDef mat-header-cell mat-sort-header> {{ column.name }}</th>
                <td *matCellDef="let row" mat-cell>
                    {{ row[column.property] }}
                </td>
            </ng-container>
          </ng-container>
  
          <tr *matHeaderRowDef="visibleColumns" mat-header-row></tr>
          <tr *matRowDef="let row; columns: visibleColumns;" class="clickable route-animations-elements" mat-row></tr>
        </table>
  
      </fury-list>
  
    </fury-page-layout-content>
  </fury-page-layout>
  


